import { render, staticRenderFns } from "./TemplateInvitersList.vue?vue&type=template&id=d97f2e86&scoped=true"
import script from "./TemplateInvitersList.vue?vue&type=script&lang=js"
export * from "./TemplateInvitersList.vue?vue&type=script&lang=js"
import style0 from "./TemplateInvitersList.vue?vue&type=style&index=0&id=d97f2e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97f2e86",
  null
  
)

export default component.exports